import { GridOverlay } from '@mui/x-data-grid';

/**
 * Component for showing an empty data grid for folder view
 */
export function FolderEmptyDataGrid() {
  return <GridOverlay>No files or folders. Click 'Create' to get started.</GridOverlay>;
}
